import { template as template_716439ec850743bbb653437c399cc5af } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { isPresent } from '@ember/utils';
import { waitFor } from '@ember/test-waiters';
import { task } from 'ember-concurrency';
import { t } from 'ember-intl';
import Portal from 'ember-stargate/components/portal';
import { task as trackedTask } from 'reactiveweb/ember-concurrency';
import OEE_STATES from 'eflex/constants/oee-states';
import SearchTag from 'eflex/components/filters/search-tag';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
export default class BiPanelStates extends Component {
    @service
    intl;
    @service
    queryRunner;
    @tracked
    isDisplayed = false;
    constructor(){
        super(...arguments);
        this.isDisplayed = this.args.states?.length > 0;
        this.args.initParam('states', this.args.states);
    }
    @action
    onChange(states) {
        this.args.updateParam('states', states);
    }
    get params() {
        return {
            startDate: this.args.startDate,
            endDate: this.args.endDate
        };
    }
    get selectedStatesBadgeText() {
        return this.args.createSearchBadgeText('states', 'state', 'criteria.selectedStates');
    }
    get selectedStates() {
        return this.args.getParam('states');
    }
    getOeeButtonNames = task({
        drop: true
    }, waitFor(async (params)=>{
        const defaultOeeStateNames = OEE_STATES.BUTTONS.map((button)=>{
            return this.intl.t(button.label).toUpperCase();
        });
        const customOeeStateQuery = await this.queryRunner.queryWithParams.perform(params, [
            {
                $match: {
                    customButtonColor: {
                        $ne: null
                    }
                }
            },
            {
                $group: {
                    _id: '$state'
                }
            },
            {
                $project: {
                    _id: 0,
                    state: '$_id'
                }
            }
        ], true);
        const customOeeStates = await this.queryRunner.runQuery.perform('OeeStates', customOeeStateQuery);
        return customOeeStates.map((result)=>result.state.toUpperCase()).concat(defaultOeeStateNames).toSorted((a, b)=>a.localeCompare(b));
    }));
    oeeStateNames = trackedTask(this, this.getOeeButtonNames, ()=>[
            this.params
        ]);
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    static{
        template_716439ec850743bbb653437c399cc5af(`
    <Portal @target="filter-fields">
      <FilterWrapper
        class="eflex-states-criteria"
        @class="align-items-end"
        @form={{@form}}
        @label="bi.biPanel.states"
        @isDisplayed={{this.isDisplayed}}
        @onChecked={{this.onDisplayedChanged}}
        @hasValue={{isPresent this.selectedStates}}
        ...attributes
      >
        <div class="input-group">
          <div class="col">
            <div class="row">
              <div class="col">
                <@form.element
                  class="oee-button-select"
                  @controlType="power-select-multiple"
                  @value={{this.selectedStates}}
                  @options={{this.oeeStateNames}}
                  @onChange={{this.onChange}}
                as |el|>
                  <el.control
                    class="sm"
                    @searchEnabled={{true}}
                    @searchField="text"
                    @placeholder={{t "bi.biPanel.statesPlaceholder"}}
                  />
                </@form.element>
              </div>
            </div>
          </div>
        </div>
      </FilterWrapper>
    </Portal>

    <Portal @target="search-badge-tags">
      <SearchTag
        @isDisplayed={{@states}}
        @text={{this.selectedStatesBadgeText}}
      />
    </Portal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
